(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js', './kotlinx-serialization-kotlinx-serialization-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-uuid-kotlinx-uuid-core'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'kotlinx-uuid-kotlinx-uuid-core'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-uuid-kotlinx-uuid-core'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'kotlinx-uuid-kotlinx-uuid-core'.");
    }
    root['kotlinx-uuid-kotlinx-uuid-core'] = factory(typeof this['kotlinx-uuid-kotlinx-uuid-core'] === 'undefined' ? {} : this['kotlinx-uuid-kotlinx-uuid-core'], this['kotlin-kotlin-stdlib-js-ir'], this['kotlinx-serialization-kotlinx-serialization-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.g1;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.h2;
  var Long = kotlin_kotlin.$_$.ug;
  var Char__plus_impl_qi7pgj = kotlin_kotlin.$_$.m2;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.l2;
  var charSequenceGet = kotlin_kotlin.$_$.ib;
  var Char = kotlin_kotlin.$_$.lg;
  var Char__minus_impl_a2frrh_0 = kotlin_kotlin.$_$.k2;
  var toLong = kotlin_kotlin.$_$.bd;
  var protoOf = kotlin_kotlin.$_$.yc;
  var objectMeta = kotlin_kotlin.$_$.xc;
  var VOID = kotlin_kotlin.$_$.ni;
  var setMetadataFor = kotlin_kotlin.$_$.zc;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var THROW_CCE = kotlin_kotlin.$_$.ah;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f2;
  var classMeta = kotlin_kotlin.$_$.lb;
  var objectCreate = kotlin_kotlin.$_$.wc;
  var Comparable = kotlin_kotlin.$_$.mg;
  var Exception = kotlin_kotlin.$_$.sg;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.l1;
  var captureStack = kotlin_kotlin.$_$.fb;
  var defineProp = kotlin_kotlin.$_$.nb;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Serializer, 'Serializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(Default, 'Default', objectMeta, Serializer);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(UUID, 'UUID', classMeta, VOID, [Comparable], VOID, {0: Default_getInstance});
  setMetadataFor(UUIDFormatException, 'UUIDFormatException', classMeta, Exception);
  //endregion
  function formatUUID(timeStampAndVersionRaw, clockSequenceVariantAndNodeRaw, includeBrackets) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$(38);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.uuid.formatUUID.<anonymous>' call
    if (includeBrackets) {
      tmp0_apply.v7(_Char___init__impl__6a9atx(123));
    }
    dumpHex(timeStampAndVersionRaw.e7(32), 4, tmp0_apply);
    tmp0_apply.v7(_Char___init__impl__6a9atx(45));
    dumpHex(timeStampAndVersionRaw.e7(16).ea(new Long(65535, 0)), 2, tmp0_apply);
    tmp0_apply.v7(_Char___init__impl__6a9atx(45));
    dumpHex(timeStampAndVersionRaw.ea(new Long(65535, 0)), 2, tmp0_apply);
    tmp0_apply.v7(_Char___init__impl__6a9atx(45));
    dumpHex(clockSequenceVariantAndNodeRaw.i8(48).ea(new Long(65535, 0)), 2, tmp0_apply);
    tmp0_apply.v7(_Char___init__impl__6a9atx(45));
    dumpHex(clockSequenceVariantAndNodeRaw.ea(new Long(-1, 65535)), 6, tmp0_apply);
    if (includeBrackets) {
      tmp0_apply.v7(_Char___init__impl__6a9atx(125));
    }
    return tmp0_apply.toString();
  }
  function dumpHex(value, numberOfOctets, out) {
    // Inline function 'kotlin.repeat' call
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < numberOfOctets)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.uuid.dumpHex.<anonymous>' call
        var octet = value.e7(imul((numberOfOctets - index | 0) - 1 | 0, 8));
        dumpHalfByte(octet.e1() >> 4, out);
        dumpHalfByte(octet.e1(), out);
      }
       while (inductionVariable < numberOfOctets);
  }
  function dumpHalfByte(value, out) {
    var half = value & 15;
    out.v7(half <= 9 ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), half) : Char__minus_impl_a2frrh(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(97), half), 10));
  }
  function parseUUID(text) {
    var textIndex = skipCharacters(text, 0, _Char___init__impl__6a9atx(123));
    var timeStampAndVersionRaw = parseOctetStride(text, textIndex, 4, 32);
    textIndex = skipCharacters(text, textIndex + 8 | 0, _Char___init__impl__6a9atx(45));
    timeStampAndVersionRaw = timeStampAndVersionRaw.mi(parseOctetStride(text, textIndex, 2, 16));
    textIndex = skipCharacters(text, textIndex + 4 | 0, _Char___init__impl__6a9atx(45));
    timeStampAndVersionRaw = timeStampAndVersionRaw.mi(parseOctetStride(text, textIndex, 2, 0));
    textIndex = skipCharacters(text, textIndex + 4 | 0, _Char___init__impl__6a9atx(45));
    var clockSequenceVariantAndNodeRaw = parseOctetStride(text, textIndex, 2, 48);
    textIndex = skipCharacters(text, textIndex + 4 | 0, _Char___init__impl__6a9atx(45));
    clockSequenceVariantAndNodeRaw = clockSequenceVariantAndNodeRaw.mi(parseOctetStride(text, textIndex, 6, 0));
    textIndex = skipCharacters(text, textIndex + 12 | 0, _Char___init__impl__6a9atx(125));
    if (textIndex < text.length) {
      var tmp$ret$1;
      // Inline function 'kotlin.text.substring' call
      var tmp0_substring = textIndex;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$1 = text.substring(tmp0_substring);
      error('extra trailing characters ' + tmp$ret$1, text, textIndex);
    }
    return Companion_getInstance().oeq(timeStampAndVersionRaw, clockSequenceVariantAndNodeRaw);
  }
  function skipCharacters(text, startIndex, a) {
    var inductionVariable = startIndex;
    var last = text.length;
    if (inductionVariable < last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var character = charSequenceGet(text, index);
        if ((character === a ? true : character === _Char___init__impl__6a9atx(32)) ? true : character === _Char___init__impl__6a9atx(9)) {
          continue $l$loop;
        }
        return index;
      }
       while (inductionVariable < last);
    return text.length;
  }
  function parseOctetStride(text, textIndex, numberOfOctets, shift) {
    if ((text.length - textIndex | 0) < imul(numberOfOctets, 2)) {
      errorTooShort(text);
    }
    var result = new Long(0, 0);
    // Inline function 'kotlin.repeat' call
    var tmp0_repeat = imul(numberOfOctets, 2);
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.uuid.parseOctetStride.<anonymous>' call
        var character = charSequenceGet(text, textIndex + index | 0);
        var tmp;
        if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
          tmp = Char__minus_impl_a2frrh_0(character, _Char___init__impl__6a9atx(48));
        } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
          tmp = Char__minus_impl_a2frrh_0(character, _Char___init__impl__6a9atx(97)) + 10 | 0;
        } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
          tmp = Char__minus_impl_a2frrh_0(character, _Char___init__impl__6a9atx(65)) + 10 | 0;
        } else {
          error('Unexpected octet character ' + new Char(character), text, textIndex + index | 0);
        }
        var halfByte = tmp;
        result = result.u8(4).mi(toLong(halfByte));
      }
       while (inductionVariable < tmp0_repeat);
    return result.u8(shift);
  }
  function error(message, text, index) {
    throw new UUIDFormatException(index === -1 ? 'Failed to parse UUID ' + text + ': ' + message : 'Failed to parse UUID ' + text + ' at position ' + index + ': ' + message);
  }
  function errorTooShort(text) {
    error('UUID string is too short', text, -1);
  }
  function Default() {
    Default_instance = this;
    Serializer.call(this, false);
  }
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Serializer(includeBrackets) {
    this.peq_1 = includeBrackets;
    this.qeq_1 = PrimitiveSerialDescriptor('UUID', STRING_getInstance());
  }
  protoOf(Serializer).ke8 = function () {
    return this.qeq_1;
  };
  protoOf(Serializer).me8 = function (decoder) {
    return UUID_init_$Create$(decoder.ceb());
  };
  protoOf(Serializer).req = function (encoder, value) {
    encoder.jec(value.f25(this.peq_1));
  };
  protoOf(Serializer).le8 = function (encoder, value) {
    return this.req(encoder, value instanceof UUID ? value : THROW_CCE());
  };
  function UUID_init_$Init$(helper, $this) {
    UUID.call($this, helper.seq_1, helper.teq_1);
    return $this;
  }
  function UUID_init_$Init$_0(uuid, $this) {
    UUID_init_$Init$(parseUUID(uuid), $this);
    return $this;
  }
  function UUID_init_$Create$(uuid) {
    return UUID_init_$Init$_0(uuid, objectCreate(protoOf(UUID)));
  }
  function Companion() {
    Companion_instance = this;
    this.neq_1 = this.oeq(new Long(0, 0), new Long(0, 0));
  }
  protoOf(Companion).oeq = function (timeStampAndVersionRaw, clockSequenceVariantAndNodeRaw) {
    return new UUID(timeStampAndVersionRaw, clockSequenceVariantAndNodeRaw);
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function UUID(timeStampAndVersionRaw, clockSequenceVariantAndNodeRaw) {
    Companion_getInstance();
    this.seq_1 = timeStampAndVersionRaw;
    this.teq_1 = clockSequenceVariantAndNodeRaw;
  }
  protoOf(UUID).toString = function () {
    return this.f25(false);
  };
  protoOf(UUID).f25 = function (includeBrackets) {
    return formatUUID(this.seq_1, this.teq_1, includeBrackets);
  };
  protoOf(UUID).hashCode = function () {
    return this.seq_1.hashCode() + this.teq_1.hashCode() | 0;
  };
  protoOf(UUID).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof UUID) {
      tmp_0 = other.teq_1.equals(this.teq_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = other.seq_1.equals(this.seq_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UUID).ueq = function (other) {
    // Inline function 'kotlin.let' call
    var tmp0_let = this.seq_1.v(other.seq_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (!(tmp0_let === 0)) {
      return tmp0_let;
    }
    return this.teq_1.v(other.teq_1);
  };
  protoOf(UUID).t8 = function (other) {
    return this.ueq(other instanceof UUID ? other : THROW_CCE());
  };
  function UUIDFormatException(message) {
    Exception_init_$Init$(message, this);
    captureStack(this, UUIDFormatException);
    this.veq_1 = message;
  }
  protoOf(UUIDFormatException).j9 = function () {
    return this.veq_1;
  };
  defineProp(protoOf(UUIDFormatException), 'message', function () {
    return this.j9();
  }, VOID);
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Default_getInstance;
  //endregion
  return _;
}));
